import React, { Suspense, useContext } from 'react'
import { LoaderContext } from 'contexts/loader-context'

const Footer = () => {
  const { footer } = useContext(LoaderContext)

  // Neighbars redesign override: this branch is single-theme (myHeineken), so
  // the new footer (v3) is forced instead of resolving CONFIGS.versionPh.
  const version = 'v3'

  const FooterVersion = React.lazy(() => import(`components/footer/${version}`))

  if (!footer) {
    return null
  }

  return (
    <Suspense fallback={<></>}>
      <FooterVersion />
    </Suspense>
  )
}

export default Footer
